module.exports = __webpack_public_path__ + "img/0088b3b.jpg";